var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnSinglestatPanel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81 79.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#3865ab;}.cls-3{fill:#84aff1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 14.91,
    x2: 81,
    y2: 14.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.12.4v29h-7V8.71H5.85a5,5,0,0,1-2,1.45A8.94,8.94,0,0,1,0,10.87V5.34a6.39,6.39,0,0,0,3.13-.76,6.36,6.36,0,0,0,2.2-1.92A4.07,4.07,0,0,0,6.15.4Zm6.43,29v-5L30.13,15.1a22.8,22.8,0,0,0,2.76-2.87,4.67,4.67,0,0,0,1-2.91A3.6,3.6,0,0,0,32.72,6.5a4.23,4.23,0,0,0-2.93-1,4,4,0,0,0-2.91,1.08A4.08,4.08,0,0,0,25.77,9.6H19.12a9.6,9.6,0,0,1,1.33-5.11A8.79,8.79,0,0,1,24.2,1.17,12.74,12.74,0,0,1,29.82,0a13.77,13.77,0,0,1,5.74,1.11,8.81,8.81,0,0,1,3.77,3.07,8,8,0,0,1,1.34,4.59A8.48,8.48,0,0,1,40,12.05a13.83,13.83,0,0,1-2.4,3.6,52.32,52.32,0,0,1-4.86,4.72l-3.47,3.2v.19H41v5.65ZM49,29.82a3.59,3.59,0,0,1-2.62-1.08,3.67,3.67,0,0,1,0-5.18A3.62,3.62,0,0,1,49,22.5a3.58,3.58,0,0,1,2.56,1.06,3.55,3.55,0,0,1,0,5.18A3.56,3.56,0,0,1,49,29.82Zm7.86-5.23V19.12L68.7.4h8.83V19.07H81v5.52H77.53v4.82h-6.7V24.59ZM71,19.07V7.82h-.22l-7,11v.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.24 61.55 27.32 43.53 0 54.29 0 79.04 81 79.04 81 47.84 53.24 61.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.24,63.55a2,2,0,0,1-1.14-.35l-25-17.4L2.77,55.86a2,2,0,1,1-1.53-3.7L26.55,41.68a2,2,0,0,1,1.91.21L53.38,59.22,78.06,46.15a2,2,0,1,1,1.88,3.53L54.17,63.32A1.91,1.91,0,0,1,53.24,63.55Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSinglestatPanel);
export default __webpack_public_path__ + "static/media/icn-singlestat-panel.987fb4d340b94084f250570bb860bc79.svg";
export { ForwardRef as ReactComponent };